
























import { staticContent } from '../../localisation/detect-lang';
import { Vue } from '../../constants/constants'
import axios from 'axios';
export default Vue.component('promo-message', {
  data() {
    return {
    
   staticContent,
    };
  
  },
  computed:{
    promos(){
      return this.$store.state.promoForm.form.data;
    }
  },
    props:{
       messagestate : String,
    }
  
 
})

